import React from "react";
import TextField from "@liveramp/motif/core/TextField";
import { Search, User } from "@liveramp/motif/icons";
import css from "./Adornments.module.css";

export default function AdornmentsOutlinedDemo() {
  return (
    <div className={css.grid}>
      <TextField
        id="outlined-start-str-adornment"
        label="Price"
        defaultValue="100"
        helperText="Start Adornment"
        InputProps={{
          startAdornment: "$"
        }}
      />
      <TextField
        id="outlined-end-str-adornment"
        label="Weight"
        defaultValue="100"
        helperText="End Adornment"
        InputProps={{
          endAdornment: "kg"
        }}
      />
      <TextField
        id="outlined-start-icon-adornment"
        label="Username"
        defaultValue="Nexus"
        helperText="Start Adornment"
        InputProps={{
          startAdornment: <User />
        }}
      />
      <TextField
        id="outlined-end-icon-adornment"
        label="Search"
        defaultValue="Nexus"
        helperText="End Adornment"
        InputProps={{
          endAdornment: <Search />
        }}
      />
    </div>
  );
}
